import { Link } from "react-router-dom";
import { HOME_PATH } from "../../routes";
import { filterItems } from "../../data/catalog";
import ItemCard from "../catalog/ItemCard";
import { useEffect, useMemo, useRef, useState } from "react";
import { useCart } from "../../context/CartContext";
import { money } from "../../utils/format";
import { buildOrderText } from "../../utils/order";
import CartRow from "./CartRow";
import OrderSummary from "./OrderSummary";

// Full-screen cart ("Your Inquiry") with the order-details form.
export default function Cart({ onClose, onEditItem, page = false }) {
  const { rows, total, savings } = useCart();
  const [on, setOn] = useState(false);
  const order = useMemo(() => {
    if (!rows.length) return null;
    const details = { rows, total };
    return { ...details, text: buildOrderText(details) };
  }, [rows, total]);
  const listRef = useRef(null);

  useEffect(() => {
    const frame = requestAnimationFrame(() => setOn(true));
    return () => cancelAnimationFrame(frame);
  }, []);

  return (
    <>
      {!page && <div className={`shade inquiryBackdrop${on ? " on" : ""}`} id="shade" onClick={onClose} />}
      <aside className={`drawer inquiryCart${page ? " cartPage" : ""}${on ? " on" : ""}`} id="drawer" aria-label="Bag">
        <div className="dhead">
          <h2>{page ? "My Bag" : "Your Inquiry"}</h2>
          <button type="button" className="x" id="closeCart" aria-label="Close bag" onClick={onClose}>
            ×
          </button>
        </div>
        {(!page || rows.length > 0) && <div className="drawerSellerNote">
          <div className="bagNoteDesktop">
            <p style={{ margin: "0 0 12px" }}>Tap <strong>Send an Inquiry</strong> to send your order details.</p>
            <p style={{ margin: 0 }}>No payment is collected on this website. Pay cash at pickup or arrange payment with me in chat.</p>
          </div>
          <div className="bagNoteMobile">
            <p style={{ margin: "0 0 12px" }}>Review your order and tap <strong>Send an Inquiry</strong> at the bottom of the page.</p>
            <p style={{ margin: 0 }}>No payment is collected on this website.</p>
          </div>
        </div>}
        <div className="cartlist" id="cartlist" ref={listRef}>
          {rows.length ? (
            rows.map((row) => <CartRow key={row.item.id} row={row} onEdit={onEditItem} />)
          ) : (
            <div className="empty">
              Your bag is empty.
              <br />
              <Link to={HOME_PATH}>Start Shopping</Link>
            </div>
          )}
        </div>
        {(!page || rows.length > 0) && <section className="bagTotalPanel" aria-label="Bag total">
          <div className="cadAboveTotal">Prices in CAD</div>
          <div className="total">
            <span>Estimated total</span>
            <span id="total">{money(total)}</span>
          </div>
          {savings > 0.005 && (
            <div id="cartSavingsTotal159" style={{ display: "flex" }}>
              <span>Total savings</span>
              <span>{money(savings)}</span>
            </div>
          )}
        </section>}
        {(!page || rows.length > 0) && <div className={`checkout${order ? " orderCreated" : ""}`}>
          <div id="bagTotalActions" />
          <div className={`notice${order ? " on" : ""}`} id="notice">
            {order && <OrderSummary order={order} />}

          </div>
        </div>}
      </aside>
      {page && <section className="cartRecommendations" aria-label="More products">
        <h2>Before you go, there’s more</h2>
        <div className="cartRecommendationGrid">
          {filterItems({ latest: true }).filter(item => !rows.some(row => row.item.id === item.id)).slice(0, 6).map(item => <ItemCard key={item.id} item={item} showStock={false} />)}
        </div>
      </section>}
    </>
  );
}
